import React from 'react';

export default function AreasStrip() {

  const areas = [
    "Waterloo",
    "Southwark",
    "London Bridge",
    "Elephant & Castle"
  ];

  return (
    <>
      <style>{`

      .areas-container {
        background: var(--orange);
        padding: 12px 5%;
        margin-top: 72px;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 14px;
        color: #fff;
        font-size: .85rem;
        font-weight: 500;
        flex-wrap: wrap;
      }

      .area-item {
        display:flex;
        align-items:center;
        white-space:nowrap;
      }

      .area-dot {
        margin-left:12px;
        opacity:.6;
      }

      /* Mobile */
      @media (max-width:768px){

        .areas-container{
          display:grid;
          grid-template-columns:1fr;
          justify-items:center;
          text-align:center;
          gap:6px;
        }

        .area-dot{
          display:none;
        }

      }

      `}</style>

      <div className="areas-container">

        <div className="area-header">
          📍 Serving SE1:
        </div>

        {areas.map((area,index)=>(
          <div key={area} className="area-item">
            {area}
            {index < areas.length-1 && (
              <span className="area-dot">•</span>
            )}
          </div>
        ))}

      </div>
    </>
  );
}